import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { AdvertiserInfoVO } from '../../../interfaces/AdvertiserInfo';
import { IInputProps, InputVariant } from '@amobee/component-library';
import { AutoCompleteMappedItem, AutoCompleteMappedResponse } from '../../../../common/components/auto-complete/auto-complete.component';
import { PlannerEndpoints } from '../../../constants/planner-endpoints.const';

@Component({
  selector: 'labels',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.scss']
})
export class LabelsComponent implements OnInit {

  @Input() group: FormGroup;
  @Input() advertiserInfo: AdvertiserInfoVO;

  maxLabelShown: number = 10;

  labelsEndpoint: string = PlannerEndpoints.planLabel;

  selectedLabels: string[];

  autoCompleteSearchProps: IInputProps = {
    compact: false,
    variant: InputVariant.TABLE,
    leftElement: 'Search',
    placeholder: 'Search',
    fluid: true,
    dark: false
  };

  constructor() { }

  ngOnInit() {
    if (this.advertiserInfo) {
      this.labelsEndpoint = PlannerEndpoints.planLabel + '?advertiserId=' + this.advertiserInfo.id
    }
    this.selectedLabels = this.labelsControl.value || [];
  }

  onSelect($event: AutoCompleteMappedItem) {
    let index = this.selectedLabels.indexOf($event.value.toString());
    if (index == -1) {
      this.selectedLabels.push($event.value.toString());
      this.labelsControl.patchValue(this.selectedLabels);
    }
  }

  removeLabel($event, label: string) {
    let index = this.selectedLabels.indexOf(label);
    if (index > -1) {
      this.selectedLabels.splice(index, 1);
      this.labelsControl.patchValue(this.selectedLabels);
    }
  }

  responseMapper = (response: any, offset: number, limit: number, searchString?: string): AutoCompleteMappedResponse => {
    // if responseMapper is not provided, will use this default one
    let items: AutoCompleteMappedItem[] = [];
    let hasNewLable = true;
    if (response.results) {
      items = response.results.map((item) => {
        if (item.name === searchString) {
          hasNewLable = false;
        }
        return {
          label: item.name,
          value: item.name,
          disabled: this.selectedLabels.includes(item.name)
        }
      });
    }
    if (searchString && searchString !== '' && hasNewLable) {
      items.unshift({
        label: searchString + ' (new)',
        value: searchString,
        disabled: this.selectedLabels.includes(searchString)
      })
    }
    return {
      results: items,
      hasMore: false
    }
  };

  get labelsControl() {
    return this.group.get("labels") as FormControl;
  }

}
